import { RunSummary } from "@/client-admin/types.gen";
import { columns } from "./columns";
import { DataTable } from "./data-table";

type Props = {
  rows: RunSummary[];
  onRowClick: (run: RunSummary) => void;
};

export function RunsTable({ rows, onRowClick }: Props) {
  return <DataTable columns={columns} data={rows} onRowClick={onRowClick} />;
}
